import $ from 'jquery';
const BLOCK_LEVEL_ELEMENTS = 'address, article, aside, audio, blockquote, canvas, dd, div, dl, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, hgroup, hr, main, nav, noscript, ol, output, p, pre, section, table, tfoot, ul, video, li';
const DEFAULT_PERMITTED_TAGS = ['a', 'abbr', 'address', 'article', 'aside', 'b', 'bdi', 'bdo', 'blockquote', 'br', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'dd', 'del', 'dfn', 'div', 'dl', 'dt', 'em', 'figcaption', 'figure', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'img', 'ins', 'kbd', 'li', 'main', 'mark', 'ol', 'p', 'pre', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'small', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'time', 'tr', 'u', 'ul', 'var', 'wbr'];
const DEFAULT_PERMITTED_ATTRIBUTES = {
  all: ['align', 'class', 'dir', 'height', 'id', 'lang', 'title', 'width'],
  a: ['href', 'data-target', 'data-toggle', 'data-via', 'name', 'target'],
  body: ['bgcolor', 'style', 'class'],
  blockquote: ['cite'],
  col: ['span', 'valign'],
  colgroup: ['span', 'valign'],
  del: ['cite', 'datetime'],
  img: ['alt', 'src'],
  ins: ['cite', 'datetime'],
  ol: ['reversed', 'start', 'type'],
  q: ['cite'],
  table: ['border', 'cellpadding', 'cellspacing', 'summary'],
  tbody: ['valign'],
  td: ['abbr', 'axis', 'colspan', 'rowspan', 'valign'],
  tfoot: ['valign'],
  th: ['abbr', 'axis', 'colspan', 'rowspan', 'scope', 'valign'],
  thead: ['valign'],
  time: ['datetime', 'pubdate'],
  tr: ['valign'],
  ul: ['type'],
  small: ['data-ic-ios-height']
};
function HtmlCleaner(tags, attributes) {
  this.permittedTags = tags === undefined ? DEFAULT_PERMITTED_TAGS : tags;
  this.permittedAttributes = attributes === undefined ? DEFAULT_PERMITTED_ATTRIBUTES : attributes;
  this.documentTags = $.merge(['style', 'html', 'head', 'title', 'body'], this.permittedTags);
  this.documentAttributes = $.extend({
    style: ['type', 'data-premailer']
  }, this.permittedAttributes);
  this.documentAttributes.all = this.documentAttributes.all.concat(['style', 'bgcolor']);
}
HtmlCleaner.prototype = {
  cleanHtml(content) {
    // eslint-disable-next-line jquery-unsafe/no-html
    let $content = $('<div>').html(content);
    let cleaned = this.cleanElement($content, this.permittedTags, this.permittedAttributes);
    return cleaned.html();
  },
  cleanElement(element, tags, attributes) {
    $(element).find('*').each((idx, elem) => {
      let $thisElement = $(elem);
      this.cleanAttributes($thisElement, attributes);
      this.cleanTags($thisElement, tags);
      this.encodeURIs($thisElement);
    });
    return element;
  },
  cleanTags($thisElement, tags) {
    let tag = $thisElement.prop('tagName').toLowerCase();
    if (tags.indexOf(tag) === -1) {
      let $contents = $thisElement.contents();
      if ($contents.length) {
        if ($thisElement.children(BLOCK_LEVEL_ELEMENTS).length) {
          $contents.unwrap();
          return;
        }
        $contents.unwrap().wrap('<p></p>');
        return;
      }
      $thisElement.remove();
    }
  },
  cleanAttributes($thisElement, attributes) {
    let element = $thisElement[0];
    let permittedAttributes = attributes;
    let attributesToRemove = '';
    if (!$thisElement.prop('tagName')) {
      return true;
    }
    let tagName = $thisElement.prop('tagName').toLowerCase();
    for (let i = 0, length = element.attributes.length; i < length; i++) {
      if (!element.attributes[i]) {
        break;
      }
      let currentAttribute = element.attributes[i].name;
      let allowedAttributes = permittedAttributes[tagName] ? $.merge($.merge([], permittedAttributes[tagName]), permittedAttributes.all) : permittedAttributes.all;
      if (allowedAttributes.indexOf(currentAttribute) === -1) {
        // @pat - We can't use $.removeAttr on boolean attributes. See https://jquery.com/upgrade-guide/3.0/#breaking-change-removeattr-no-longer-sets-properties-to-false
        if ($.expr.match.bool.test(currentAttribute)) {
          $thisElement.prop(currentAttribute, false);
        } else {
          attributesToRemove += `${currentAttribute} `;
        }
      }
    }
    $thisElement.removeAttr(attributesToRemove);
  },
  encodeURIs($thisElement) {
    let thisElement = $thisElement[0];
    let attributeName = thisElement.hasAttribute('src') ? 'src' : 'href';
    let uri = thisElement.getAttribute(attributeName);
    if (uri) {
      let encodedUri = uri.replace(/{{.*?}}/g, function (match) {
        return encodeURIComponent(match);
      });
      if (this._uriIsNotAllowedForAttribute(attributeName, encodedUri)) {
        encodedUri = '#';
      }
      $thisElement.attr(attributeName, encodedUri);
    }
  },
  isJavascriptURI(uri) {
    return uri.match(/^\s*javascript:/i);
  },
  isDataURI(uri) {
    return uri.match(/^\s*data:/i);
  },
  isJavascriptOrDataUri(uri) {
    return this.isDataURI(uri) || this.isJavascriptURI(uri);
  },
  _uriIsNotAllowedForAttribute(attribute, uri) {
    return this.isJavascriptURI(uri) || this.isDataURI(uri) && attribute === 'href';
  }
};
export default HtmlCleaner;